import React, { useState, useEffect, useRef } from 'react';
import { collection, query, orderBy, getDocs, onSnapshot, where, doc, updateDoc, Timestamp } from "firebase/firestore";
import { db } from "./firebaseConfig"; // Certifique-se de que esse arquivo exporta { db }
import io from 'socket.io-client';
import Swal from "sweetalert2";
import bcrypt from "bcryptjs";
import notificationSound from './assets/chamando_garcom.mp3';
import GarcomLogin from "./components/GarcomLogin";
import { solicitarPermissaoNotificacoes } from "../src/solicitarPermissaoNotificacoes"; // ajuste o caminho se precisar


const socket = io('http://localhost:3000');

const intervalosPorSetor = {
  Deck: { min: 100, max: 199 },
  Salao: { min: 200, max: 299 },
  PeNaAreia: { min: 300, max: 399 },
  Piscina: { min: 700, max: 799 },
  Lounge: { min: 500, max: 599 },
};

function GarcomScreen() {
  const [logado, setLogado] = useState(false);
  const [nomeGarcom, setNomeGarcom] = useState('');
  const [garcons, setGarcons] = useState([]);
  const [garcomSelecionado, setGarcomSelecionado] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [chamadas, setChamadas] = useState([]);
  const [setorSelecionado, setSetorSelecionado] = useState('');
  const [tempoEspera, setTempoEspera] = useState({});
  const [tempoAtendimento, setTempoAtendimento] = useState({});
  const [somAtivado, setSomAtivado] = useState(false);


//formatar tempo
  const formatarTempo = (segundos) => {
    const minutos = Math.floor(segundos / 60);
    const segundosRestantes = segundos % 60;
    return `${minutos}m ${segundosRestantes}s`;
  };
  

//função para calcular tempo total de atendimento
const calcularTempoTotal = (tempoEspera, tempoAtendimento) => {
  if (!tempoEspera || !tempoAtendimento) return "N/A";

  // Converte os tempos para segundos
  const segundosEspera = converterParaSegundos(tempoEspera);
  const segundosAtendimento = converterParaSegundos(tempoAtendimento);
  const totalSegundos = segundosEspera + segundosAtendimento;

  return formatarTempo(totalSegundos);
};

// Função auxiliar para converter "Xm Ys" para segundos
const converterParaSegundos = (tempo) => {
  if (!tempo.includes("m")) return parseInt(tempo) || 0; // Caso venha só em segundos

  const [minutos, segundos] = tempo.split("m ").map(t => parseInt(t) || 0);
  return minutos * 60 + segundos;
};

const ativarSomDasChamadas = async () => {
  try {
    await audioRef.current.play();
    localStorage.setItem("somAtivo", "true");
    setSomAtivado(true);
    console.log("🔊 Som ativado com sucesso!");
  } catch (error) {
    console.warn("⚠️ Navegador bloqueou o som:", error);
    Swal.fire({
      icon: "warning",
      title: "Permissão necessária",
      text: "Toque novamente para ativar o som.",
    });
  }
};


useEffect(() => {
  const ativado = localStorage.getItem("somAtivo") === "true";
  setSomAtivado(ativado);
}, []);



//useEffect para atualizar o tempo de atendimento em tempo real
useEffect(() => {
  const atualizarTemposAtendimento = () => {
    const agora = new Date();

    const novosTemposAtendimento = {};
    chamadas.forEach((chamada) => {
      if (chamada.status === "em_andamento" && chamada.aceitoEm) {
        const diferencaSegundos = Math.floor((agora - new Date(chamada.aceitoEm)) / 1000);
        novosTemposAtendimento[chamada.id] = formatarTempo(diferencaSegundos);
      }
    });

    setTempoAtendimento(novosTemposAtendimento);
  };

  const intervalo = setInterval(atualizarTemposAtendimento, 1000);
  return () => clearInterval(intervalo);
}, [chamadas]);


//useEffect para atualizar o tempo de espera em tempo real
useEffect(() => {
  const atualizarTempos = () => {
    const agora = new Date();

    // Atualiza o tempo de espera das chamadas pendentes
    const novosTemposEspera = {};
    chamadas.forEach((chamada) => {
      if (chamada.status === "pendente" && chamada.data_hora) {
        const diferencaSegundos = Math.floor((agora - new Date(chamada.data_hora)) / 1000);
        novosTemposEspera[chamada.id] = formatarTempo(diferencaSegundos);
      }
    });

    setTempoEspera(novosTemposEspera);
  };

  const intervalo = setInterval(atualizarTempos, 1000);
  return () => clearInterval(intervalo);
}, [chamadas]);

  
  // 🔹 Use useRef() para armazenar a referência do intervalo corretamente
  const notificationInterval = useRef(null);
  const audioRef = useRef(new Audio(notificationSound));

  // 🔹 Função para tocar som de notificação
const playNotificationSound = async () => {
  try {
    const audio = audioRef.current;
    audio.currentTime = 0;

    const playPromise = audio.play();

    if (playPromise !== undefined) {
      await playPromise.catch((e) => {
        console.warn("🔇 Som bloqueado pelo navegador até haver interação do usuário.");
      });
    }
  } catch (error) {
    console.error("Erro ao reproduzir o som:", error);
  }
};

const mostrarNotificacaoVisual = (titulo, corpo) => {
  if (Notification.permission === "granted") {
    new Notification(titulo, {
      body: corpo,
      icon: "/https://cdn-icons-png.flaticon.com/512/1827/1827392.png", // coloque esse ícone em /public/
    });
  } else {
    Notification.requestPermission().then((permissao) => {
      if (permissao === "granted") {
        new Notification(titulo, { body: corpo });
      }
    });
  }
};


  // 🔹 Inicia o loop de notificações (som a cada 1 minuto)
  const startNotificationLoop = () => {
    playNotificationSound();
    if (!notificationInterval.current) {
      notificationInterval.current = setInterval(() => {
        playNotificationSound();
      }, 600000); // Notificação a cada 1 minuto
    }
  };

  // 🔹 Para o loop de notificações
  const stopNotificationLoop = () => {
    if (notificationInterval.current) {
      clearInterval(notificationInterval.current);
      notificationInterval.current = null;
    }
  };



// ✅ Função para aceitar chamada (permitindo apenas uma em andamento por garçom)
const aceitarChamada = async (idChamada) => {
  try {
    // Verifica se o garçom já tem uma chamada em andamento
    const chamadasEmAndamento = chamadas.filter(
      (c) => c.status === "em_andamento" && c.garcom === nomeGarcom
    );

    if (chamadasEmAndamento.length > 0) {
      Swal.fire({
        title: "Atenção!",
        text: "Você já tem uma chamada em andamento. Finalize-a antes de aceitar outra.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return; // Impede de aceitar outra chamada
    }

    // Busca a chamada para capturar o tempo de espera
    const chamada = chamadas.find(c => c.id === idChamada);
    if (!chamada) {
      Swal.fire({
        title: "Erro!",
        text: "Chamada não encontrada.",
        icon: "error",
      });
      return;
    }

    const agora = new Date();
    const diferencaSegundos = Math.floor((agora - new Date(chamada.data_hora)) / 1000);
    const tempoEsperaFormatado = formatarTempo(diferencaSegundos);

    // Prossegue para aceitar a chamada
    const chamadaRef = doc(db, "chamadas", idChamada);

await updateDoc(chamadaRef, {
  status: "em_andamento",
  garcom: nomeGarcom,
  aceitoEm: agora.toISOString(),
  tempoEspera: tempoEsperaFormatado,
  mensagem: `Solicitação aceita pelo garçom ${nomeGarcom}.`,
  tipo: chamada.tipo, // 🔧 <- Adicionado aqui para preservar o tipo da solicitação
});


    // Para a notificação quando a chamada for aceita
    stopNotificationLoop();

    Swal.fire({
      title: "Chamada aceita!",
      text: `O cliente esperou ${tempoEsperaFormatado} antes de ser atendido.`,
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
    });

  } catch (error) {
    console.error("Erro ao aceitar chamada:", error);
    Swal.fire({
      title: "Erro!",
      text: "Não foi possível aceitar a chamada.",
      icon: "error",
    });
  }
};

// 🔹 Função para formatar tempo em minutos e segundos
const formatarHora = (timestamp) => {
  if (!timestamp) return "N/A"; // Caso não tenha um horário salvo

  const data = new Date(timestamp);
  const horas = data.getHours().toString().padStart(2, "0");
  const minutos = data.getMinutes().toString().padStart(2, "0");

  return `${horas}:${minutos}`;
};



// Buscar a lista de garçons via Firestore e ordenar por nome
useEffect(() => {
  const fetchGarcons = async () => {
    try {
      const q = query(collection(db, "garcons"), orderBy("nome"));
      const querySnapshot = await getDocs(q);
      const garconsList = [];
      querySnapshot.forEach((doc) => {
        // Inclua também o ID do documento se necessário
        garconsList.push({ id: doc.id, ...doc.data() });
      });
      setGarcons(garconsList);
    } catch (error) {
      console.error('Erro ao buscar garçons:', error);
      setErro('Erro ao carregar lista de garçons.');
    }
  };

  fetchGarcons();
}, []);

// 🔑 Função de login
const handleLogin = async () => {
  if (!garcomSelecionado || !setorSelecionado) {
    setErro("Por favor, selecione um garçom e um setor.");
    return;
  }

  try {
    const garcomQuery = query(
      collection(db, "garcons"),
      where("id", "==", garcomSelecionado)
    );

    const querySnapshot = await getDocs(garcomQuery);

    if (querySnapshot.empty) {
      setErro("Usuário não encontrado.");
      return;
    }

    const garcomDoc = querySnapshot.docs[0];
    const garcomData = garcomDoc.data();
    const senhaCorreta = bcrypt.compareSync(senha, garcomData.senha);

    if (senhaCorreta) {
      setNomeGarcom(garcomData.nome);
      setLogado(true);
      setErro("");

      const dataAtual = new Date().toISOString().split("T")[0];

      const sessaoData = {
        nome: garcomData.nome,
        setor: setorSelecionado,
        data: dataAtual,
      };

      // 💾 Salva a sessão no localStorage
      localStorage.setItem("garcomSessao", JSON.stringify(sessaoData));

      Swal.fire({
        title: "Login bem-sucedido!",
        text: `Bem-vindo, ${garcomData.nome}!`,
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });


const atualizarTokenGarcom = async (idGarcom) => {
  try {
    // 1. Solicita permissão e recupera token
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("❌ Permissão negada para notificações.");
      return;
    }

    const token = await getToken(messaging, {
      vapidKey: "BEpLJtS7DuY4tJgSner4ZsEvEmJlIfbmB2SwryuXCoavvrBMiEXTHHQsQ26BEvAqzzxUBdPmaLO6la_E9PYvo9s",
    });

    if (!token) {
      console.log("❌ Token não foi gerado.");
      return;
    }

    console.log("📲 Token gerado:", token);

    // 2. Busca o documento do garçom pelo campo `id`
    const q = query(collection(db, "garcons"), where("id", "==", idGarcom));
    const snapshot = await getDocs(q);

    if (snapshot.empty) {
      console.log("❌ Garçom não encontrado com id:", idGarcom);
      return;
    }

    const garcomDoc = snapshot.docs[0];
    const garcomRef = doc(db, "garcons", garcomDoc.id);

    // 3. Atualiza o campo notificacaoToken
    await updateDoc(garcomRef, {
      notificacaoToken: token,
    });

    console.log("✅ Token salvo com sucesso no Firestore!");

  } catch (err) {
    console.error("🚨 Erro ao atualizar token:", err);
  }
};


    } else {
      setErro("Senha incorreta.");
    }
  } catch (error) {
    console.error("Erro no login:", error);
    setErro("Erro no servidor.");
  }
};

// ✅ Verifica se já existe uma sessão salva ao iniciar o componente
useEffect(() => {
  const sessaoSalva = localStorage.getItem("garcomSessao");

  if (sessaoSalva) {
    const { nome, setor, data } = JSON.parse(sessaoSalva);
    const dataHoje = new Date().toISOString().split("T")[0];

    if (data === dataHoje) {
      setNomeGarcom(nome);
      setSetorSelecionado(setor);
      setLogado(true);
      console.log(`✅ Sessão restaurada para ${nome} - Setor: ${setor}`);
    } else {
      // 🧹 Se a data não for de hoje, limpa a sessão
      localStorage.removeItem("garcomSessao");
      console.log("🗑️ Sessão expirada e removida.");
    }
  }
}, []);

// 🚪 Função para sair com confirmação
const handleLogout = () => {
  Swal.fire({
    title: "Tem certeza que deseja sair?",
    text: "Sua sessão será encerrada.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Sim, sair",
    cancelButtonText: "Cancelar",
  }).then((result) => {
    if (result.isConfirmed) {
      // 🗑️ Remove a sessão
      localStorage.removeItem("garcomSessao");
      setLogado(false);
      setNomeGarcom("");
      setSetorSelecionado("");
      setSenha("");

      Swal.fire({
        title: "Sessão encerrada!",
        text: "Você saiu com sucesso.",
        icon: "info",
        timer: 1500,
        showConfirmButton: false,
      });
    }
  });
};

// 📅 Função para retornar a data atual no formato YYYY-MM-DD
const getTodayDate = () => new Date().toISOString().split("T")[0];

// ✅ UseEffect para sincronizar chamadas APENAS após login e com setor selecionado
useEffect(() => {
  if (!logado || !setorSelecionado) return;  // ✅ Só ativa após login e setor definido

  const today = getTodayDate();

  console.log(`🔔 Escutando chamadas em tempo real para o setor: ${setorSelecionado} (apenas do dia ${today})`);

  // 🔍 Query otimizada para buscar apenas chamadas do dia atual e com status relevante
  const q = query(
    collection(db, "chamadas"),
    where("setor", "==", setorSelecionado),
    where("status", "in", ["pendente", "em_andamento", "finalizado"]),
    where("data_hora", ">=", `${today} 00:00:00`),
    where("data_hora", "<=", `${today} 23:59:59`)
  );

  const unsubscribe = onSnapshot(q, (querySnapshot) => {
    const chamadasAtualizadas = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

// 🔄 Atualiza o estado com as chamadas do dia atual
setChamadas(chamadasAtualizadas);

// 🚨 Verifica e notifica chamadas pendentes dentro do intervalo do setor
const novasChamadasPendentes = chamadasAtualizadas.filter(
  (chamada) =>
    chamada.status === "pendente" &&
    chamada.mesa >= intervalosPorSetor[setorSelecionado]?.min &&
    chamada.mesa <= intervalosPorSetor[setorSelecionado]?.max
);

if (novasChamadasPendentes.length > 0) {
  console.log("🚨 Nova chamada pendente detectada!");

  // Som
  playNotificationSound();

  // Notificação visual
  const primeiraChamada = novasChamadasPendentes[0];
  mostrarNotificacaoVisual(
    "🚨 Nova chamada de mesa",
    `Mesa ${primeiraChamada.mesa} solicitou atendimento!`
  );

  // Som contínuo a cada 1min (opcional)
  startNotificationLoop();
} else {
  stopNotificationLoop();
}



  });

  // 🧹 Limpeza ao sair ou trocar de setor
  return () => {
    console.log(`🛑 Parando de escutar chamadas para o setor: ${setorSelecionado}`);
    unsubscribe();
    stopNotificationLoop();  // 🛑 Para notificações sonoras e vibrações
  };

}, [logado, setorSelecionado, nomeGarcom]);  // 📝 Reexecuta com mudanças no login, setor e nome do garçom


// ✅ Função para finalizar a chamada
const finalizarChamada = async (idChamada) => {
  try {
    const chamadaRef = doc(db, "chamadas", idChamada);
    const chamada = chamadas.find(c => c.id === idChamada);
    const agora = new Date();

    // Calcula o tempo de atendimento
    const diferencaSegundos = chamada.aceitoEm 
      ? Math.floor((agora - new Date(chamada.aceitoEm)) / 1000) 
      : 0;
    const tempoAtendimentoFormatado = formatarTempo(diferencaSegundos);

    await updateDoc(chamadaRef, {
      status: "finalizado",
      finalizadoEm: agora.toISOString(),
      tempoAtendimento: tempoAtendimentoFormatado,
    });

    Swal.fire({
      title: "Atendimento finalizado!",
      text: `Tempo total de atendimento: ${tempoAtendimentoFormatado}.`,
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
    });

  } catch (error) {
    console.error("Erro ao finalizar chamada:", error);
    Swal.fire({
      title: "Erro!",
      text: "Não foi possível finalizar a chamada.",
      icon: "error",
    });
  }
};



  // 🛡️ Formulário de Login usando o componente GarcomLogin
if (!logado) {
  return (
    <GarcomLogin
      garcons={garcons}
      garcomSelecionado={garcomSelecionado}
      setGarcomSelecionado={setGarcomSelecionado}
      setorSelecionado={setorSelecionado}
      setSetorSelecionado={setSetorSelecionado}
      senha={senha}
      setSenha={setSenha}
      handleLogin={handleLogin}
      erro={erro}
      intervalosPorSetor={intervalosPorSetor}
    />
  );
}



  // Mapeamento de cores e nomes para exibição do setor
  const setorCores = {
    Deck: "#019191",
    Salao: "#94c93d",
    PeNaAreia: "#fdc913",
    Piscina: "#dc2746",
    Lounge: "#f7742e",
  };

  const setorNomes = {
    Deck: "Deck",
    Salao: "Salão",
    PeNaAreia: "Pé na Areia",
    Piscina: "Piscina",
    Lounge: "Lounge",
  };


  {/* Definição das quantidades antes do return */}
const totalChamadasFinalizadas = chamadas.filter(c => c.status === 'finalizado' && c.tipo === 'chamada' && c.garcom === nomeGarcom).length;
const totalContasFinalizadas = chamadas.filter(c => c.status === 'finalizado' && c.tipo === 'conta' && c.garcom === nomeGarcom).length;

  return (
  <div className="container mt-4">
    <div className="card p-4 shadow-lg">
      {/* Mensagem de Boas-Vindas */}
      <h1 className="text-center mb-3">
  Bem-vindo, {nomeGarcom && `${nomeGarcom.split(' ')[0]} ${nomeGarcom.split(' ').slice(-1)[0]}`}! <i className="fas fa-user text-dark"></i>
</h1>
{!somAtivado && (
  <button
    onClick={ativarSomDasChamadas}
    className="btn btn-outline-primary w-100 mb-3 d-flex align-items-center justify-content-center gap-2"
  >
    <i className="fas fa-volume-up"></i> Ativar Som das Chamadas
  </button>
)}



      {/* Exibição do Setor */}
      <h4 className="text-center mb-4">
        Setor:{" "}
        <span
          className="badge px-3 py-2"
          style={{ backgroundColor: setorCores[setorSelecionado] || "#6c757d", color: "#fff" }}
        >
          {setorNomes[setorSelecionado] || "Não definido"}
        </span>
      </h4>

      {/* Botão de Logout */}
      <button className="btn btn-danger w-100 mb-4 d-flex align-items-center justify-content-center gap-2" onClick={handleLogout}>
        <i className="fas fa-sign-out-alt text-light"></i> Sair
      </button>

      <div className="row">
{/* Chamadas Pendentes */}
<div className="col-12 col-md-6 mb-4">
  <div className="card shadow-sm border-0 rounded-3">
    <div className="card-header bg-warning text-white rounded-top text-center">
      <h5 className="mb-0">
        <i className="fas fa-bell me-2"></i> Chamadas Pendentes
      </h5>
    </div>
    <ul className="list-group list-group-flush">
      {chamadas.filter(c => c.status === "pendente" && c.tipo === "chamada").length === 0 ? (
        <li className="list-group-item text-center py-4 text-muted">
          Nenhuma chamada pendente.
        </li>
      ) : (
        chamadas
          .filter(c => c.status === "pendente" && c.tipo === "chamada")
          .sort((a, b) => new Date(a.data_hora) - new Date(b.data_hora)) // 🔄 Ordena da mais antiga para a mais recente
          .map((c, index, array) => {
            const horaChamada = formatarHora(c.data_hora, "HH:mm");
            const mostrarPulseira = String(c.pulseira || "").trim() !== "";

            return (
              <li 
                key={c.id} 
                className={`list-group-item border-0 py-3 ${index !== array.length - 1 ? 'border-bottom' : ''}`} 
                style={{ borderBottom: "1px solid #ddd" }} // 🔹 Borda única entre as chamadas
              >
                {/* Card das Informações */}
                <div className="w-100 p-3 bg-light rounded shadow-sm">
                  <div className="d-flex flex-wrap justify-content-between gap-2">
                    <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
                      <i className="fas fa-chair me-1"></i> Mesa {c.mesa}
                    </span>
                    {mostrarPulseira && (
                      <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
                        <i className="fas fa-id-card me-1"></i> Pulseira: {c.pulseira}
                      </span>
                    )}
                  </div>
                  <div className="d-flex flex-wrap justify-content-between gap-2 mt-2">
                    <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
                      <i className="fas fa-clock me-1"></i> Hora: {horaChamada}
                    </span>
                    <span className="badge bg-warning text-dark px-3 py-2 flex-grow-1 text-center">
                      ⏳ Espera: {tempoEspera[c.id] || "0m 0s"}
                    </span>
                  </div>
                </div>

                {/* Botão Aceitar */}
                <div className="mt-3 d-flex">
                  <button
  className="btn btn-primary btn-lg w-100 d-flex align-items-center justify-content-center gap-2"
  onClick={() => aceitarChamada(c.id)}
>
  <i className="fas fa-check"></i> Aceitar
</button>

                </div>
              </li>
            );
          })
      )}
    </ul>
  </div>
</div>





{/* Chamadas em Andamento */}
<div className="col-12 col-md-6 mb-4">
  <div className="card shadow-sm border-0 rounded-3">
    <div className="card-header bg-info text-white rounded-top text-center">
      <h5 className="mb-0">
        <i className="fas fa-hourglass-half me-2"></i> Chamadas em Andamento
      </h5>
    </div>
    <ul className="list-group list-group-flush">
      {chamadas.filter(c => c.status === "em_andamento" && c.tipo === "chamada" && c.garcom === nomeGarcom).length === 0 ? (
        <li className="list-group-item text-center py-4 text-muted">
          Nenhuma chamada em andamento.
        </li>
      ) : (
        chamadas
          .filter(c => c.status === "em_andamento" && c.tipo === "chamada" && c.garcom === nomeGarcom)
          .map(c => {
            const tempoAtend = tempoAtendimento[c.id] || "0m 0s";

            return (
              <li key={c.id} className="list-group-item border-0 border-bottom py-3">
                {/* Bloco de Informações - Ocupa toda a largura */}
                <div className="w-100 p-3 bg-light rounded shadow-sm">
                  <div className="d-flex flex-wrap justify-content-between gap-2">
                    <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
                      <i className="fas fa-chair me-1"></i> Mesa {c.mesa}
                    </span>
                    {String(c.pulseira || "").trim() !== "" && (
  <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
    <i className="fas fa-id-card me-1"></i> Pulseira: {c.pulseira}
  </span>
)}
                  </div>
                  <div className="d-flex flex-wrap justify-content-between gap-2 mt-2">
                    <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
                      <i className="fas fa-clock me-1"></i> Hora: {formatarHora(c.data_hora, "HH:mm")}
                    </span>
                    <span className="badge bg-info text-white px-3 py-2 flex-grow-1 text-center">
                      🕒 Atendimento: {tempoAtend}
                    </span>
                  </div>
                </div>

                {/* Botão Finalizar */}
                <div className="mt-3 d-flex">
                  <button
                    className="btn btn-success btn-lg w-100 d-flex align-items-center justify-content-center gap-2"
                    onClick={() => finalizarChamada(c.id)}
                  >
                    <i className="fas fa-flag-checkered"></i> Finalizar
                  </button>
                </div>
              </li>
            );
          })
      )}
    </ul>
  </div>
</div>




  
         {/* Fechamento de Contas Pendentes */}
<div className="col-12 col-md-6 mb-4">
  <div className="card shadow-sm border-0 rounded-3">
    <div className="card-header bg-warning text-white rounded-top text-center">
      <h5 className="mb-0">
        <i className="fas fa-file-invoice me-2"></i> Fechamento de Contas Pendentes
      </h5>
    </div>
    <ul className="list-group list-group-flush">
      {chamadas.filter(c => c.status === "pendente" && c.tipo === "conta").length === 0 ? (
        <li className="list-group-item text-center py-4 text-muted">
          Nenhuma conta pendente.
        </li>
      ) : (
        chamadas
          .filter(c => c.status === "pendente" && c.tipo === "conta")
          .sort((a, b) => new Date(a.data_hora) - new Date(b.data_hora)) // 🕒 Ordena pela data/hora (mais antiga primeiro)
          .map((c, index) => {
            return (
              <li key={c.id} className="list-group-item border-0 border-bottom py-3">
                {/* Bloco de Informações - Ajustado para ocupar toda a largura */}
                <div className="w-100 p-3 bg-light rounded shadow-sm">
                  <div className="d-flex flex-wrap justify-content-between gap-2">
                    <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
                      <i className="fas fa-chair me-1"></i> Mesa {c.mesa}
                    </span>
                    {String(c.pulseira || "").trim() !== "" && (
  <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
    <i className="fas fa-id-card me-1"></i> Pulseira: {c.pulseira}
  </span>
)}
                  </div>
                  <div className="d-flex flex-wrap justify-content-between gap-2 mt-2">
                    <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
                      <i className="fas fa-clock me-1"></i> Hora: {formatarHora(c.data_hora, "HH:mm")}
                    </span>
                    <span className="badge bg-warning text-dark px-3 py-2 flex-grow-1 text-center">
                      ⏳ Espera: {tempoEspera[c.id] || "0m 0s"}
                    </span>
                  </div>
                </div>

                {/* Botão Aceitar */}
                <div className="mt-3 d-flex">
                  <button
  className="btn btn-primary btn-lg w-100 d-flex align-items-center justify-content-center gap-2"
  onClick={() => aceitarChamada(c.id)}
>
  <i className="fas fa-check"></i> Aceitar
</button>

                </div>
              </li>
            );
          })
      )}
    </ul>
  </div>
</div>


{/* Fechamento de Contas em Andamento */}
<div className="col-12 col-md-6 mb-4">
  <div className="card shadow-sm border-0 rounded-3">
    <div className="card-header bg-info text-white rounded-top text-center">
      <h5 className="mb-0">
        <i className="fas fa-clock me-2"></i> Fechamento de Contas em Andamento
      </h5>
    </div>
    <ul className="list-group list-group-flush">
      {chamadas.filter(c => c.status === "em_andamento" && c.tipo === "conta" && c.garcom === nomeGarcom).length === 0 ? (
        <li className="list-group-item text-center py-4 text-muted">
          Nenhuma conta em andamento.
        </li>
      ) : (
        chamadas
          .filter(c => c.status === "em_andamento" && c.tipo === "conta" && c.garcom === nomeGarcom)
          .map(c => {
            const tempoAtend = tempoAtendimento[c.id] || "0m 0s";

            return (
              <li key={c.id} className="list-group-item border-0 border-bottom py-3">
                {/* Bloco de Informações - Ajustado para ocupar toda a largura */}
                <div className="w-100 p-3 bg-light rounded shadow-sm">
                  <div className="d-flex flex-wrap justify-content-between gap-2">
                    <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
                      <i className="fas fa-chair me-1"></i> Mesa {c.mesa}
                    </span>
                    {String(c.pulseira || "").trim() !== "" && (
  <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
    <i className="fas fa-id-card me-1"></i> Pulseira: {c.pulseira}
  </span>
)}
                  </div>
                  <div className="d-flex flex-wrap justify-content-between gap-2 mt-2">
                    <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
                      <i className="fas fa-clock me-1"></i> Hora: {formatarHora(c.data_hora, "HH:mm")}
                    </span>
                    <span className="badge bg-info text-white px-3 py-2 flex-grow-1 text-center">
                      🕒 Atendimento: {tempoAtend}
                    </span>
                  </div>
                </div>

                {/* Botão Finalizar */}
                <div className="mt-3 d-flex">
                  <button
                    className="btn btn-success btn-lg w-100 d-flex align-items-center justify-content-center gap-2"
                    onClick={() => finalizarChamada(c.id)}
                  >
                    <i className="fas fa-flag-checkered"></i> Finalizar
                  </button>
                </div>
              </li>
            );
          })
      )}
    </ul>
  </div>
</div>

</div>
  


<div className="container my-4">
  <div className="row gy-4">
{/* Chamadas Finalizadas */}
<div className="col-12 col-md-6 mb-4">
  <div className="card shadow-sm border-0 rounded-3 d-flex flex-column w-100" style={{ minHeight: "120px" }}>
    <div className="card-header bg-success text-white rounded-top text-center">
      <h5 className="mb-0 d-flex align-items-center justify-content-between">
        <span>
          <i className="fas fa-check-circle me-2"></i> Chamadas Finalizadas
        </span>
        <span className="badge bg-light text-dark ms-2">{totalChamadasFinalizadas}</span>
      </h5>
    </div>
    <ul className="list-group list-group-flush flex-grow-1">
      {totalChamadasFinalizadas === 0 ? (
        <li className="list-group-item text-center py-4 text-muted flex-grow-1 d-flex align-items-center justify-content-center">
          Nenhuma chamada finalizada.
        </li>
      ) : (
        chamadas
          .filter(c => c.status === "finalizado" && c.tipo === "chamada" && c.garcom === nomeGarcom)
          .sort((a, b) => new Date(b.data_hora) - new Date(a.data_hora)) // 🔄 Ordena da mais recente para a mais antiga
          .map(c => {
            const horaCriacao = formatarHora(c.data_hora, "HH:mm"); // Formatação de Hora
            const tempoTotal = calcularTempoTotal(c.tempoEspera, c.tempoAtendimento);

            return (
              <li key={c.id} className="list-group-item border-0 border-bottom py-3">
                {/* Bloco de Informações - Ajustado para ocupar toda a largura */}
                <div className="w-100 p-3 bg-light rounded shadow-sm">
                  <div className="d-flex flex-wrap justify-content-between gap-2">
                    <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
                      <i className="fas fa-chair me-1"></i> Mesa {c.mesa}
                    </span>
                    {String(c.pulseira || "").trim() !== "" && (
  <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
    <i className="fas fa-id-card me-1"></i> Pulseira: {c.pulseira}
  </span>
)}
                  </div>
                  <div className="d-flex flex-wrap justify-content-between gap-2 mt-2">
                    <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
                      <i className="fas fa-clock me-1"></i> Hora: {horaCriacao}
                    </span>
                  </div>
                </div>

                {/* Badges de Tempo */}
                <div className="mt-3 d-flex flex-wrap justify-content-center justify-content-md-start gap-2">
                  <span className="badge bg-warning text-dark px-3 py-2">
                    ⏳ Espera: {c.tempoEspera || "N/A"}
                  </span>
                  <span className="badge bg-info text-white px-3 py-2">
                    🕒 Atendimento: {c.tempoAtendimento || "N/A"}
                  </span>
                  <span className="badge bg-success text-white px-3 py-2">
                    🕒 Total: {tempoTotal}
                  </span>
                </div>
              </li>
            );
          })
      )}
    </ul>
  </div>
</div>







{/* Contas Finalizadas */}
<div className="col-12 col-md-6 mb-4">
  <div className="card shadow-sm border-0 rounded-3 d-flex flex-column w-100" style={{ minHeight: "120px" }}>
    <div className="card-header bg-success text-white rounded-top text-center">
      <h5 className="mb-0 d-flex align-items-center justify-content-between">
        <span>
          <i className="fas fa-file-invoice-dollar me-2"></i> Contas Finalizadas
        </span>
        <span className="badge bg-light text-dark ms-2">{totalContasFinalizadas}</span>
      </h5>
    </div>
    <ul className="list-group list-group-flush flex-grow-1">
      {totalContasFinalizadas === 0 ? (
        <li className="list-group-item text-center py-4 text-muted flex-grow-1 d-flex align-items-center justify-content-center">
          Nenhuma conta finalizada.
        </li>
      ) : (
        chamadas
          .filter(c => c.status === "finalizado" && c.tipo === "conta" && c.garcom === nomeGarcom)
          .sort((a, b) => new Date(b.data_hora) - new Date(a.data_hora)) // 🔄 Ordena da mais recente para a mais antiga
          .map(c => {
            const horaCriacao = formatarHora(c.data_hora, "HH:mm"); // Formatação de Hora
            const tempoTotal = calcularTempoTotal(c.tempoEspera, c.tempoAtendimento);

            return (
              <li key={c.id} className="list-group-item border-0 border-bottom py-3">
                {/* Bloco de Informações - Ajustado para ocupar toda a largura */}
                <div className="w-100 p-3 bg-light rounded shadow-sm">
                  <div className="d-flex flex-wrap justify-content-between gap-2">
                    <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
                      <i className="fas fa-chair me-1"></i> Mesa {c.mesa}
                    </span>
                    {String(c.pulseira || "").trim() !== "" && (
  <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
    <i className="fas fa-id-card me-1"></i> Pulseira: {c.pulseira}
  </span>
)}
                  </div>
                  <div className="d-flex flex-wrap justify-content-between gap-2 mt-2">
                    <span className="badge bg-secondary-subtle text-dark px-3 py-2 flex-grow-1 text-center">
                      <i className="fas fa-clock me-1"></i> Hora: {horaCriacao}
                    </span>
                  </div>
                </div>

                {/* Badges de Tempo */}
                <div className="mt-3 d-flex flex-wrap justify-content-center justify-content-md-start gap-2">
                  <span className="badge bg-warning text-dark px-3 py-2">
                    ⏳ Espera: {c.tempoEspera || "N/A"}
                  </span>
                  <span className="badge bg-info text-white px-3 py-2">
                    🕒 Atendimento: {c.tempoAtendimento || "N/A"}
                  </span>
                  <span className="badge bg-success text-white px-3 py-2">
                    🕒 Total: {tempoTotal}
                  </span>
                </div>
              </li>
            );
          })
      )}
    </ul>
  </div>
</div>



  </div>
  </div>
  </div>
  </div>
  );
  
}

export default GarcomScreen;
